"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPE = {
  EMPTY: "empty",
  DEFAULT: "default",
  PRIMARY: "primary",
  INFO: "info",
  LIGHT: "light",
  BORDER: "border"
};
var SIZE = {
  MEDIUM: "medium",
  SMALL: "small"
};

var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getFormattedOptions", function () {
      var _this$props = _this.props,
          optionList = _this$props.options,
          selectedValue = _this$props.value;
      var setValue = ""; // $FlowFixMe

      var options = optionList.map(function (option, key) {
        var name;
        var value;
        var icon = null;

        if (_typeof(option) === "object") {
          name = option.name;
          value = option.value;

          if (option.icon) {
            icon = option.icon;
          }
        } else {
          name = option;
          value = option;
        }

        if (value && selectedValue && selectedValue !== "" && selectedValue !== null && value.toString() === selectedValue.toString()) {
          setValue = {
            name: name,
            value: value
          };
        } else if (_this.props.defaultSelected && key === 0) {
          setValue = {
            name: name,
            value: value
          };
        }

        return {
          name: name,
          value: value,
          icon: icon
        };
      });
      return {
        value: setValue,
        options: options
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (name, value) {
      if (value !== "no-results") {
        _this.setState({
          value: {
            name: name,
            value: value
          },
          isOpen: false
        });

        _this.props.onChange(value, name);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function () {
      var options = _this.state.options;
      var searchable = _this.props.searchable;

      if (options && options.length > 0) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, searchable && /*#__PURE__*/_react.default.createElement("div", {
          key: "search",
          className: "search-input dropdown-list-item"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          icon: "search"
        }), /*#__PURE__*/_react.default.createElement("input", {
          onClick: _this.onClickInput,
          onChange: _this.onSearchChange.bind(_assertThisInitialized(_this))
        })), options.map(function (_ref, key) {
          var value = _ref.value,
              name = _ref.name,
              icon = _ref.icon;
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "dropdown-list-item",
            key: "".concat(key, "_").concat(value),
            onClick: function onClick() {
              return _this.onClick(name, value);
            }
          }, icon, name);
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getFieldErrors", function (error) {
      return error !== null ? /*#__PURE__*/_react.default.createElement("div", {
        className: "form-errors"
      }, error) : "";
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function () {
      var options = _this.props.options;

      if (options && options.length > 0) {
        _this.setState(function (state) {
          return {
            isOpen: !state.isOpen
          };
        });
      }
    });

    _this.state = {
      isOpen: false,
      value: null,
      options: []
    }; // $FlowFixMe Forced to do that for perf issues

    _this.onClickInput = _this.onClickInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$getFormattedOpt = this.getFormattedOptions(),
          options = _this$getFormattedOpt.options,
          value = _this$getFormattedOpt.value;

      this.setState({
        options: options,
        value: value
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.options !== this.props.options) {
        var _this$getFormattedOpt2 = this.getFormattedOptions(),
            options = _this$getFormattedOpt2.options,
            value = _this$getFormattedOpt2.value;

        this.setState({
          options: options,
          value: value
        });
      }
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(e) {
      var _this$getFormattedOpt3 = this.getFormattedOptions(),
          options = _this$getFormattedOpt3.options;

      var userInput = e.currentTarget.value; // Filter our options that don't contain the user's input

      var filteredOptions = options.filter(function (option) {
        return option.name.toLowerCase().indexOf(userInput.toLowerCase()) > -1;
      });

      if (filteredOptions.length === 0) {
        filteredOptions = [{
          name: "No Results",
          value: "no-results"
        }];
      }

      this.setState({
        options: filteredOptions
      });
    }
  }, {
    key: "onClickInput",
    value: function onClickInput() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          value = _this$state.value;
      var selectedName = null;
      var _this$props2 = this.props,
          options = _this$props2.options,
          placeholder = _this$props2.placeholder,
          error = _this$props2.error,
          type = _this$props2.type,
          hasShadow = _this$props2.hasShadow,
          size = _this$props2.size,
          className = _this$props2.className;

      if (value) {
        selectedName = value.name;
      }

      var isSelected = selectedName !== null;
      var hasErrors = error !== null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-block ".concat(type, " ").concat(size, " ").concat(className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("form-select", {
          "dropdown-open": isOpen,
          "has-errors": hasErrors,
          "with-shadow": hasShadow
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "selected-dropdown",
        onClick: this.toggleDropdown
      }, isSelected ? /*#__PURE__*/_react.default.createElement("span", null, selectedName) : /*#__PURE__*/_react.default.createElement("span", {
        className: "placeholder"
      }, placeholder), /*#__PURE__*/_react.default.createElement("span", {
        className: "selector pull-right"
      }, isOpen && options && options.length > 0 ? /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "chevron-up"
      }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "chevron-down"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-list"
      }, this.getOptions(), " "))), this.getFieldErrors(error));
    }
  }]);

  return Select;
}(_react.Component);

_defineProperty(Select, "defaultProps", {
  onChange: function onChange() {},
  defaultSelected: false,
  searchable: false,
  value: "",
  error: null,
  type: TYPE.BORDER,
  hasShadow: false,
  size: SIZE.MEDIUM,
  className: ""
});

_defineProperty(Select, "TYPE", TYPE);

_defineProperty(Select, "SIZE", SIZE);

Select.propTypes = {
  onChange: _propTypes.default.func,
  options: _propTypes.default.array.isRequired,
  placeholder: _propTypes.default.string.isRequired,
  defaultSelected: _propTypes.default.bool,
  searchable: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  error: _propTypes.default.string,
  type: _propTypes.default.oneOf([TYPE.DEFAULT, TYPE.EMPTY, TYPE.LIGHT, TYPE.PRIMARY, TYPE.INFO, TYPE.BORDER]),
  size: _propTypes.default.oneOf([SIZE.MEDIUM, SIZE.SMALL]),
  hasShadow: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = Select;
exports.default = _default;